import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/NewsView.vue')
  },
  {
    path: '/news/:id',
    name: 'newsDetail',
    component: () => import('../views/NewsDetail.vue')
  },
  {
    path: '/corsi',
    name: 'corsi',
    component: () => import('../views/CorsiView.vue')
  },
  {
    path: '/corsi/:id',
    name: 'corsoDetail',
    component: () => import('../views/CorsiDetail.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
